  <template lang="html">
  <div class="onboarding-guide">
    <Guide
      :content="content"
      :contentVideo="contentVideo"
      contentHeading="Website Pages & Content"
      :closeLink="closeLink"
      :nextLink="nextLink"
      :previousLink="previousLink"/>
  </div>
</template>

<script>
import Guide from '@/components/Guide'

export default {
  name: 'OnboardingPages',

  components: {
    Guide
  },

  props: {
    siteId: String,
    companyId: String
  },

  computed: {
    closeLink() {
      return {
        name: 'site',
        params: {
          companyId: this.companyId, siteId: this.siteId
        }
      }
    },

    previousLink() {
      return {
        name: 'onboarding-intro',
        params: {
          companyId: this.companyId, siteId: this.siteId
        }
      }
    },

    nextLink() {
      return {
        name: 'onboarding-settings',
        params: {
          companyId: this.companyId, siteId: this.siteId
        }
      }
    },

    content() {
      return `
        <p>You’ll no doubt be spending most of your time in the <strong>Pages</strong> section of the admin area. Here, you can see a list of your pages, re-order them, and create new ones.</p>
        <p>You can configure a range of settings for each page, such as choosing to <strong>show it in the navigation</strong>, <strong>setting a password</strong> and more.</p>
        `
    },

    contentVideo() {
      return 'https://page-maker-pro.s3.eu-west-2.amazonaws.com/videos/pages.mp4'
    }
  }
}
</script>
